(function () {
  var BANNER_CLASS = 'ha-account-referral-banner-mount';
  var LOADER_CLASS = 'ha-account-referral-banner-loader';
  var YOTPO_ROOT_ID = 'ha-yotpo-rewards-root';
  var YOTPO_LOADER_URL =
    'https://cdn-widgetsrepository.yotpo.com/v1/loader/W8pc8iY7liEnAE4uW577LxsofcRyBlJ1GCdZNP8X';
  var booted = false;
  var injectTimer = null;
  var isInjectingBanner = false;
  var yotpoBooted = false;
  var overlayWatcherStarted = false;
  var overlayPreservationStarted = false;
  var isClosing = false;
  var cachedOverlay = null;
  var CLOSE_BTN_CLASS = 'ha-yotpo-rewards-close';
  var STASHED_CLASS = 'ha-yotpo-rewards-stashed';
  var isOpening = false;
  var DEBUG =
    window.location.search.indexOf('ha-rewards-debug') !== -1 ||
    window.localStorage.getItem('ha-rewards-debug') === '1';

  function log() {
    if (!DEBUG) return;
    var args = ['[ha-rewards]'].concat(Array.prototype.slice.call(arguments));
    console.log.apply(console, args);
  }

  function getYotpoRoot() {
    return document.getElementById(YOTPO_ROOT_ID);
  }

  function getRewardsWidgetHost() {
    var root = getYotpoRoot();
    if (!root) return null;

    return (
      root.querySelector('.yotpo-widget-my-rewards-widget') ||
      root.querySelector('.yotpo-widget-instance') ||
      root
    );
  }

  function isOverlayUsable(overlay) {
    if (!overlay) return false;
    return !!(
      overlay.querySelector('.yotpo-popup-tile-wrapper') ||
      overlay.querySelector('.yotpo-rewards-history') ||
      overlay.querySelector('.yotpo-no-rewards-wrapper')
    );
  }

  function getRewardsSnapshot() {
    var root = getYotpoRoot();
    var widget = document.querySelector('.yotpo-widget-my-rewards-widget');
    var triggers = widget
      ? Array.prototype.slice.call(
          widget.querySelectorAll('button, a, [role="button"], [class*="rewards-history"]')
        )
      : [];

    return {
      rootFound: !!root,
      myRewardsWidget: document.querySelectorAll('.yotpo-widget-my-rewards-widget').length,
      overlays: document.querySelectorAll('.yotpo-loyalty-popup-overlay').length,
      swellAPI: !!(window.swellAPI && window.swellAPI.showPopupByType),
      swell: !!(window.swell && window.swell.showPopupByType),
      triggers: triggers.slice(0, 8).map(function (node) {
        return {
          tag: node.tagName,
          className: node.className,
          text: (node.textContent || '').trim().slice(0, 80),
          inactive: node.classList.contains('yotpo-inactive-button'),
        };
      }),
      yotpoContainerReady: !!window.yotpoWidgetsContainer,
    };
  }

  function getTemplateHtml() {
    var template = document.getElementById('ha-account-referral-banner-template');
    return template ? template.innerHTML.trim() : '';
  }

  function isVisible(node) {
    if (!node) return false;
    if (node.offsetParent !== null) return true;
    var rects = node.getClientRects();
    return rects && rects.length > 0;
  }

  function getActiveMainView(app) {
    var views = app.querySelectorAll('.frcp-main-view');
    for (var i = 0; i < views.length; i += 1) {
      if (isVisible(views[i])) return views[i];
    }
    return app.querySelector('.frcp-main-view');
  }

  function isProfileView(app) {
    var hash = (window.location.hash || '').toLowerCase().replace(/^#/, '');

    if (hash.indexOf('profile') !== -1 || hash.indexOf('profil') !== -1) {
      return true;
    }

    var active = app.querySelector('.frcp-nav-button[active="true"], .frcp-nav-button--active');
    if (active) {
      var route = (
        active.getAttribute('data-to') ||
        active.getAttribute('href') ||
        active.getAttribute('data-route') ||
        ''
      ).toLowerCase();

      if (route.indexOf('profile') !== -1 || route.indexOf('profil') !== -1) {
        return true;
      }

      return /profil|profile/i.test((active.textContent || '').trim());
    }

    if (!hash || hash === '/' || hash === 'account' || hash.indexOf('account/') === 0) {
      var profileView = app.querySelector('.frcp-profile.frcp-main-view, .frcp-main .frcp-profile');
      if (profileView && isVisible(profileView)) {
        return true;
      }
    }

    return hash === '' || hash === '#';
  }

  function getProfileView(app) {
    var main = app.querySelector('.frcp-main');
    if (!main) return null;
    return main.querySelector('.frcp-profile');
  }

  function getBannerParent(app) {
    if (!isProfileView(app)) return null;
    return getProfileView(app);
  }

  function isBannerCorrectlyPlaced(mount, parent) {
    if (!mount || !parent) return false;
    return mount.parentElement === parent && !mount.previousElementSibling;
  }

  function insertAtTop(parent, node) {
    if (!parent || !node) return;
    parent.insertBefore(node, parent.firstChild);
  }

  function ensureYotpoLoader() {
    if (document.querySelector('script[src*="' + YOTPO_LOADER_URL + '"]')) return;

    var script = document.createElement('script');
    script.src = YOTPO_LOADER_URL;
    script.async = true;
    (document.head || document.documentElement).appendChild(script);
  }

  function getRewardsWidgetInstance() {
    var root = getYotpoRoot();
    if (!root) return null;
    return root.querySelector('.yotpo-widget-instance[data-yotpo-instance-id]');
  }

  function hasRewardsWidgetRendered() {
    return document.querySelectorAll('.yotpo-widget-my-rewards-widget').length > 0;
  }

  function initYotpoWidgets(scope, attempt) {
    attempt = attempt || 0;
    if (!scope) return;

    ensureYotpoLoader();

    var instances = scope.querySelectorAll('.yotpo-widget-instance[data-yotpo-instance-id]');
    if (!instances.length) return;

    var container = window.yotpoWidgetsContainer;
    if (container) {
      if (typeof container.initWidget === 'function') {
        instances.forEach(function (node) {
          container.initWidget(node);
        });
        log('initWidget', getRewardsSnapshot());

        if (!hasRewardsWidgetRendered() && attempt < 40) {
          window.setTimeout(function () {
            initYotpoWidgets(scope, attempt + 1);
          }, 250);
        }
        return;
      }
      if (typeof container.initWidgets === 'function') {
        container.initWidgets();
        log('initWidgets', getRewardsSnapshot());

        if (!hasRewardsWidgetRendered() && attempt < 40) {
          window.setTimeout(function () {
            initYotpoWidgets(scope, attempt + 1);
          }, 250);
        }
        return;
      }
    }

    if (attempt < 40) {
      window.setTimeout(function () {
        initYotpoWidgets(scope, attempt + 1);
      }, 250);
    }
  }

  function waitForRewardsWidget(callback, attempt) {
    attempt = attempt || 0;

    if (hasRewardsWidgetRendered()) {
      callback(true);
      return;
    }

    var root = getYotpoRoot();
    if (root) {
      initYotpoWidgets(root, 0);
    }

    if (attempt >= 40) {
      callback(false);
      return;
    }

    window.setTimeout(function () {
      waitForRewardsWidget(callback, attempt + 1);
    }, 200);
  }

  function bootYotpoRewards() {
    var root = getYotpoRoot();
    if (!root) {
      log('missing root', YOTPO_ROOT_ID);
      return;
    }

    if (yotpoBooted) {
      if (!hasRewardsWidgetRendered()) {
        initYotpoWidgets(root, 0);
      }
      return;
    }

    yotpoBooted = true;
    initYotpoWidgets(root);
    startOverlayWatcher();
    startOverlayPreservation();
    log('bootYotpoRewards', getRewardsSnapshot());
  }

  function isInactive(node) {
    return !!(node && node.classList && node.classList.contains('yotpo-inactive-button'));
  }

  function rememberOverlay(overlay) {
    if (!overlay) return;
    cachedOverlay = overlay;
  }

  function restoreCachedOverlay() {
    if (!cachedOverlay) return null;

    if (!cachedOverlay.isConnected) {
      var root = getYotpoRoot();
      if (root) {
        root.appendChild(cachedOverlay);
        log('restore cached overlay');
      }
    }

    return cachedOverlay.isConnected ? cachedOverlay : null;
  }

  function findRewardsOverlay() {
    var root = getYotpoRoot();
    if (root) {
      var inRoot = root.querySelector('.yotpo-loyalty-popup-overlay');
      if (inRoot) {
        rememberOverlay(inRoot);
        return inRoot;
      }
    }

    var inDocument = document.querySelector('.yotpo-loyalty-popup-overlay');
    if (inDocument) {
      rememberOverlay(inDocument);
      return inDocument;
    }

    return restoreCachedOverlay();
  }

  function reinitRewardsWidget() {
    var instance = getRewardsWidgetInstance();
    var container = window.yotpoWidgetsContainer;
    if (!instance || !container || typeof container.initWidget !== 'function') return;

    container.initWidget(instance);
    log('reinitRewardsWidget', getRewardsSnapshot());
  }

  function restoreYotpoDom() {
    var root = getYotpoRoot();
    if (!root) return;

    var overlay = document.querySelector('.yotpo-loyalty-popup-overlay');
    if (overlay && overlay.parentElement !== root) {
      root.appendChild(overlay);
      log('restore overlay to root');
    }
  }

  function attachOverlayToViewport(overlay) {
    var root = getYotpoRoot();
    if (!root || !overlay) return;

    if (overlay.parentElement !== root) {
      root.appendChild(overlay);
    }
  }

  function prepareYotpoRootForOpen() {
    var root = getYotpoRoot();
    if (root) root.removeAttribute('aria-hidden');
  }

  function blurYotpoFocus() {
    var root = getYotpoRoot();
    var active = document.activeElement;
    if (root && active && root.contains(active) && typeof active.blur === 'function') {
      active.blur();
    }
  }

  function ensureCloseButton(overlay) {
    if (!overlay) return;

    var target = overlay.querySelector('.yotpo-popup-tile-wrapper') || overlay;
    if (target.querySelector('.' + CLOSE_BTN_CLASS)) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = CLOSE_BTN_CLASS;
    btn.setAttribute('aria-label', 'Fermer');
    btn.innerHTML = '<span aria-hidden="true">&times;</span>';
    target.appendChild(btn);
  }

  function resetOverlayForOpen(overlay) {
    if (!overlay) return;
    overlay.classList.remove(STASHED_CLASS);
    overlay.style.removeProperty('display');
    overlay.style.removeProperty('pointer-events');
    overlay.removeAttribute('aria-hidden');
    overlay.removeAttribute('hidden');
  }

  function hideOverlayState(overlay) {
    if (!overlay) return;
    overlay.classList.remove('yotpo-open');
    overlay.classList.add(STASHED_CLASS);
    overlay.style.removeProperty('display');
    overlay.style.setProperty('pointer-events', 'none', 'important');
    overlay.setAttribute('aria-hidden', 'true');
  }

  function releaseRewardsUiLock() {
    document.body.classList.remove('ha-yotpo-rewards-open');
    document.body.style.removeProperty('overflow');

    var root = getYotpoRoot();
    if (root) {
      root.classList.remove('ha-yotpo-rewards-active');
      root.setAttribute('aria-hidden', 'true');
      root.style.setProperty('pointer-events', 'none', 'important');
    }

    document.querySelectorAll('.yotpo-loyalty-popup-overlay').forEach(function (node) {
      hideOverlayState(node);
      stashOverlay(node);
    });
  }

  function normalizeOverlayPresentation(overlay) {
    if (!overlay) return;

    var tile = overlay.querySelector('.yotpo-popup-tile-wrapper');
    var nodes = tile ? [overlay, tile].concat(Array.prototype.slice.call(tile.querySelectorAll('*'))) : [overlay];

    nodes.forEach(function (node) {
      if (!node || !node.style) return;
      node.style.removeProperty('box-shadow');
      node.style.removeProperty('filter');
    });

    if (tile) {
      tile.style.setProperty('margin', '0 auto', 'important');
      tile.style.removeProperty('text-align');
      tile.style.removeProperty('align-items');
    }
  }

  function closeRewardsOverlay() {
    if (isClosing) return;
    isClosing = true;
    isOpening = false;

    releaseRewardsUiLock();
    blurYotpoFocus();

    window.setTimeout(function () {
      isClosing = false;
    }, 300);
  }

  function findRewardsHistoryTrigger(root) {
    var widget =
      (root && root.querySelector('.yotpo-widget-my-rewards-widget')) ||
      document.querySelector('.yotpo-widget-my-rewards-widget');

    if (!widget) return null;

    var prioritySelectors = [
      '.yotpo-rewards-history-tile',
      '.yotpo-rewards-history-title',
      '.yotpo-rewards-history-title-text',
      '.yotpo-rewards-history',
      '[class*="rewards-history-tile"]',
      '[class*="rewards-history-title"]',
      '[class*="rewards-history"]',
      '[data-yotpo-element="rewards-history"]',
    ];

    for (var i = 0; i < prioritySelectors.length; i += 1) {
      var node = widget.querySelector(prioritySelectors[i]);
      if (node) {
        return node.closest('button, a, [role="button"]') || node;
      }
    }

    var candidates = widget.querySelectorAll('button, a, [role="button"], [tabindex="0"]');
    for (var j = 0; j < candidates.length; j += 1) {
      var candidate = candidates[j];
      if (isInactive(candidate)) continue;

      var text = (candidate.textContent || '').trim().toLowerCase();
      if (!text) continue;
      if (/redeem|échanger|points/.test(text)) continue;
      if (/reward|historique|history|récompense|recompense|activity|activité/.test(text)) {
        return candidate;
      }
    }

    return null;
  }

  function callSwellRewardsPopup() {
    if (window.swellAPI && typeof window.swellAPI.showPopupByType === 'function') {
      window.swellAPI.showPopupByType('RewardsPopup');
      log('swellAPI.showPopupByType');
      return true;
    }

    if (window.swell && typeof window.swell.showPopupByType === 'function') {
      window.swell.showPopupByType('RewardsPopup');
      log('swell.showPopupByType');
      return true;
    }

    return false;
  }

  function stashOverlay(overlay) {
    var root = getYotpoRoot();
    if (!root || !overlay) return;
    rememberOverlay(overlay);
    if (overlay.parentElement !== root) {
      root.appendChild(overlay);
    }
  }

  function showRewardsOverlay() {
    if (isClosing) return false;

    var root = getYotpoRoot();
    var overlay = findRewardsOverlay();

    if (!overlay || !isOverlayUsable(overlay)) return false;

    prepareYotpoRootForOpen();
    resetOverlayForOpen(overlay);
    restoreYotpoDom();
    attachOverlayToViewport(overlay);
    stashOverlay(overlay);
    overlay.classList.add('yotpo-open');
    normalizeOverlayPresentation(overlay);
    ensureCloseButton(overlay);

    if (root) {
      root.classList.add('ha-yotpo-rewards-active');
      root.removeAttribute('aria-hidden');
      root.style.removeProperty('pointer-events');
    }

    document.body.classList.add('ha-yotpo-rewards-open');

    window.setTimeout(function () {
      if (window.HaYotpoReferralUx && typeof window.HaYotpoReferralUx.scheduleRewardsCopy === 'function') {
        window.HaYotpoReferralUx.scheduleRewardsCopy(root || document, 0);
      } else if (window.HaYotpoReferralUx && typeof window.HaYotpoReferralUx.applyRewardsHistoryCopy === 'function') {
        window.HaYotpoReferralUx.applyRewardsHistoryCopy(root || document);
      }
    }, 200);

    return true;
  }

  function waitForRewardsOverlay(attempt) {
    attempt = attempt || 0;

    if (showRewardsOverlay()) {
      isOpening = false;
      log('overlay visible', attempt);
      return;
    }

    if (attempt >= 40) {
      isOpening = false;
      console.warn('[ha-rewards] Overlay introuvable. haRewardsDebug.snapshot()');
      return;
    }

    window.setTimeout(function () {
      waitForRewardsOverlay(attempt + 1);
    }, 150);
  }

  function dispatchClick(node) {
    if (!node || typeof node.click !== 'function') return false;

    try {
      node.dispatchEvent(
        new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window,
        })
      );
    } catch (error) {
      node.click();
    }

    return true;
  }

  function triggerYotpoRewardsPopup() {
    var root = getYotpoRoot();

    if (callSwellRewardsPopup()) {
      return true;
    }

    var popUpTrigger =
      (root && root.querySelector('.yotpo-widget-my-rewards-widget .yotpo-rewards-pop-up')) ||
      (root && root.querySelector('.yotpo-rewards-pop-up:not([data-ha-open-yotpo-rewards])'));
    if (popUpTrigger) {
      log('pop-up trigger', popUpTrigger.className);
      dispatchClick(popUpTrigger);
      return true;
    }

    var historyTrigger = findRewardsHistoryTrigger(root);
    if (historyTrigger) {
      log('history trigger', historyTrigger.className, historyTrigger.textContent);
      dispatchClick(historyTrigger);
      return true;
    }

    document.dispatchEvent(new CustomEvent('swell:setup'));
    return false;
  }

  function openYotpoRewardsFallback() {
    isOpening = true;
    bootYotpoRewards();
    prepareYotpoRootForOpen();
    log('openYotpoRewards:fallback:start', getRewardsSnapshot());

    waitForRewardsWidget(function (ready) {
      log('openYotpoRewards:fallback:widget', ready, getRewardsSnapshot());
      reinitRewardsWidget();
      triggerYotpoRewardsPopup();
      waitForRewardsOverlay();
    });
  }

  function openYotpoRewards() {
    if (isClosing) return;

    isOpening = true;
    bootYotpoRewards();
    prepareYotpoRootForOpen();

    var existingOverlay = findRewardsOverlay();
    if (existingOverlay && isOverlayUsable(existingOverlay)) {
      resetOverlayForOpen(existingOverlay);
      if (showRewardsOverlay()) {
        isOpening = false;
        log('openYotpoRewards:reuse', getRewardsSnapshot());
        return;
      }
    }

    log('openYotpoRewards:start', getRewardsSnapshot());
    openYotpoRewardsFallback();
  }

  function startOverlayPreservation() {
    if (overlayPreservationStarted) return;
    overlayPreservationStarted = true;

    var observer = new MutationObserver(function (mutations) {
      if (isClosing) return;

      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.removedNodes, function (node) {
          if (!node || node.nodeType !== 1) return;

          if (node.classList && node.classList.contains('yotpo-loyalty-popup-overlay')) {
            log('overlay removed from DOM, stashing');
            window.setTimeout(function () {
              stashOverlay(node);
            }, 0);
            return;
          }

          var nested =
            node.querySelector &&
            node.querySelector('.yotpo-loyalty-popup-overlay');
          if (nested) {
            log('overlay removed with parent, stashing');
            window.setTimeout(function () {
              stashOverlay(nested);
            }, 0);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  function startOverlayWatcher() {
    if (overlayWatcherStarted) return;
    overlayWatcherStarted = true;

    var observer = new MutationObserver(function () {
      if (isClosing || !isOpening) return;

      var overlay = findRewardsOverlay();
      if (!overlay || overlay.classList.contains(STASHED_CLASS)) return;

      if (overlay.classList.contains('yotpo-open') && !document.body.classList.contains('ha-yotpo-rewards-open')) {
        showRewardsOverlay();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style'],
    });
  }

  function removeBannerLoader(parent) {
    if (!parent) return;
    var loader = parent.querySelector('.' + LOADER_CLASS);
    if (loader) loader.remove();
  }

  function showBannerLoader(parent) {
    if (!parent) return;
    if (parent.querySelector('.' + BANNER_CLASS)) return;
    if (parent.querySelector('.' + LOADER_CLASS)) return;

    var loader = document.createElement('div');
    loader.className = LOADER_CLASS;
    loader.setAttribute('aria-busy', 'true');
    loader.setAttribute('aria-live', 'polite');
    insertAtTop(parent, loader);
  }

  function injectBanner(app) {
    if (isInjectingBanner) return;

    var parent = getBannerParent(app);
    var existing = app.querySelector('.' + BANNER_CLASS);

    if (!parent) {
      if (existing) existing.remove();
      app.querySelectorAll('.' + LOADER_CLASS).forEach(function (node) {
        node.remove();
      });
      return;
    }

    var html = getTemplateHtml();
    if (!html) {
      removeBannerLoader(parent);
      if (existing) existing.remove();
      return;
    }

    if (existing && isBannerCorrectlyPlaced(existing, parent)) {
      removeBannerLoader(parent);
      applyBannerLabels(existing);
      return;
    }

    isInjectingBanner = true;

    try {
      if (existing) existing.remove();

      var mount = document.createElement('div');
      mount.className = BANNER_CLASS;
      mount.innerHTML = html;
      insertAtTop(parent, mount);
      applyBannerLabels(mount);
    } finally {
      isInjectingBanner = false;
      removeBannerLoader(parent);
    }
  }

  function setBannerTextIfNeeded(node, text) {
    if (!node || text == null || text === '') return;
    if (node.textContent === text) return;
    node.textContent = text;
  }

  function applyBannerLabels(mount) {
    if (!mount) return;

    var labels = window.HaYotpoReferralUx && window.HaYotpoReferralUx.labels;
    if (labels) {
      var title = mount.querySelector('.ha-account-referral-banner__title');
      var btnReferral = mount.querySelector('.ha-account-referral-banner__btn--primary');
      var btnRewards = mount.querySelector('[data-ha-open-yotpo-rewards]');

      setBannerTextIfNeeded(title, labels.accountBannerTitle);
      setBannerTextIfNeeded(btnReferral, labels.accountBannerBtnReferral);
      setBannerTextIfNeeded(btnRewards, labels.accountBannerBtnRewards);
    }

    if (
      window.HaYotpoReferralUx &&
      typeof window.HaYotpoReferralUx.applyAccountReferralBannerCopy === 'function'
    ) {
      window.HaYotpoReferralUx.applyAccountReferralBannerCopy(document);
    }
  }

  function scheduleInject(app) {
    if (!app || isInjectingBanner) return;

    var parent = getBannerParent(app);
    var html = getTemplateHtml();

    if (!html) {
      app.querySelectorAll('.' + BANNER_CLASS).forEach(function (node) {
        node.remove();
      });
      app.querySelectorAll('.' + LOADER_CLASS).forEach(function (node) {
        node.remove();
      });
      return;
    }

    if (parent) {
      var mount = app.querySelector('.' + BANNER_CLASS);
      if (mount && isBannerCorrectlyPlaced(mount, parent)) {
        removeBannerLoader(parent);
        applyBannerLabels(mount);
        return;
      }

      if (!parent.querySelector('.' + BANNER_CLASS) && !parent.querySelector('.' + LOADER_CLASS)) {
        showBannerLoader(parent);
      }
    }

    window.clearTimeout(injectTimer);
    injectTimer = window.setTimeout(function () {
      injectBanner(app);
    }, 120);
  }

  function bindApp(app) {
    bootYotpoRewards();
    scheduleInject(app);

    var profileWatchTimer = null;
    var profileObserver = new MutationObserver(function () {
      if (!isProfileView(app) || isInjectingBanner) return;
      window.clearTimeout(profileWatchTimer);
      profileWatchTimer = window.setTimeout(function () {
        if (isInjectingBanner) return;
        var profile = getProfileView(app);
        var mount = app.querySelector('.' + BANNER_CLASS);
        if (!profile) return;
        if (!mount || mount.parentElement !== profile || profile.firstElementChild !== mount) {
          injectBanner(app);
        }
      }, 120);
    });

    function observeProfile() {
      var profile = getProfileView(app);
      if (!profile) return;
      profileObserver.disconnect();
      profileObserver.observe(profile, { childList: true });
    }

    observeProfile();

    app.addEventListener('click', function (event) {
      var rewardsBtn = event.target.closest('[data-ha-open-yotpo-rewards]');
      if (rewardsBtn) {
        event.preventDefault();
        event.stopPropagation();
        openYotpoRewards();
        return;
      }

      if (event.target.closest('.frcp-nav-button, [data-to], [data-route]')) {
        window.setTimeout(function () {
          observeProfile();
          scheduleInject(app);
        }, 80);
        window.setTimeout(function () {
          observeProfile();
          scheduleInject(app);
        }, 300);
      }
    });

    var observer = new MutationObserver(function () {
      if (isInjectingBanner) return;
      observeProfile();
      scheduleInject(app);
    });

    observer.observe(app, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['active', 'class', 'style'],
    });
  }

  function boot() {
    var app = document.querySelector('.frcp-app');
    if (!app) return false;

    if (!booted) {
      booted = true;
      bindApp(app);
    }

    scheduleInject(app);
    return true;
  }

  function waitForApp() {
    if (boot()) return;

    var tries = 0;
    var interval = window.setInterval(function () {
      tries += 1;
      if (boot() || tries >= 80) {
        window.clearInterval(interval);
      }
    }, 250);
  }

  window.haRewardsDebug = {
    snapshot: getRewardsSnapshot,
    open: openYotpoRewards,
    fallback: openYotpoRewardsFallback,
    close: closeRewardsOverlay,
    restore: restoreYotpoDom,
    release: releaseRewardsUiLock,
    enable: function () {
      window.localStorage.setItem('ha-rewards-debug', '1');
      DEBUG = true;
      console.log('[ha-rewards] Debug activé. Rechargez la page.');
    },
    disable: function () {
      window.localStorage.removeItem('ha-rewards-debug');
      DEBUG = false;
    },
  };

  document.addEventListener('click', function (event) {
    if (!document.body.classList.contains('ha-yotpo-rewards-open')) return;

    if (event.target.closest('.' + CLOSE_BTN_CLASS)) {
      event.preventDefault();
      event.stopPropagation();
      closeRewardsOverlay();
      return;
    }

    if (
      event.target.closest(
        '.yotpo-close-button, .yotpo-close-modal, .yotpo-loyalty-popup-overlay [class*="close"]'
      )
    ) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      closeRewardsOverlay();
      return;
    }

    var root = getYotpoRoot();
    if (!root || !root.classList.contains('ha-yotpo-rewards-active')) return;

    var overlay = root.querySelector('.yotpo-loyalty-popup-overlay');
    var tile = root.querySelector('.yotpo-popup-tile-wrapper');
    var card = tile || overlay;

    if (card && !card.contains(event.target) && root.contains(event.target)) {
      closeRewardsOverlay();
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && document.body.classList.contains('ha-yotpo-rewards-open')) {
      closeRewardsOverlay();
    }
  });

  document.addEventListener('frcp:loaded', waitForApp);
  document.addEventListener('frcp.navigation.mounted', waitForApp);
  document.addEventListener('frcp.customPage.mounted', waitForApp);
  document.addEventListener('DOMContentLoaded', waitForApp);
  window.addEventListener('hashchange', waitForApp);
  window.addEventListener('popstate', waitForApp);
})();
